import { MapElementFactory } from 'vue2-google-maps';
import Coordinates from '../Maps/Coordinates.js';
import Shapes from '../Maps/Shapes.js';
import first from 'lodash-es/first';

export default MapElementFactory({
    ctr: () => google.maps.DirectionsRenderer,
    //// The following is optional, but necessary if the constructor takes multiple arguments
    //// e.g. for GroundOverlay
    // ctrArgs: (bounds, text, map) => [options],
    events: ['directions_changed'],

    // Mapped Props will automatically set up
    //   this.$watch('propertyName', (v) => instance.setPropertyName(v))
    //
    // If you specify `twoWay`, then it also sets up:
    //   google.maps.event.addListener(instance, 'propertyName_changed', () => {
    //     this.$emit('propertyName_changed', instance.getPropertyName())
    //   })
    //
    // If you specify `noBind`, then neither will be set up. You should manually
    // create your watchers in `afterCreate()`.
    mappedProps: {
        routeIndex: { type: Number },
        options: { type: Object },
        panel: {},
        directions: { type: Object },
        //// If you have a property that comes with a `_changed` event,
        //// you can specify `twoWay` to automatically bind the event, e.g. Map's `zoom`:
        // zoom: {type: Number, twoWay: true}
    },
    // Any other properties you want to bind. Note: Must be in Object notation
    props: {
        deliveryProjects: {
            required: true,
        },
        currentDeliveryProject: {
            required: false,
        },
        drawingManager: {
            required: true,
        },
        canEdit: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    created() {
        this.setUp();

        this.drawDeliveryProject();
    },
    // Actions you want to perform before creating the object instance using the
    // provided constructor (for example, you can modify the `options` object).
    // If you return a promise, execution will suspend until the promise resolves
    beforeCreate(options) {
    },
    // Actions to perform after creating the object instance.
    afterCreate(rendererInstance) {
    },

    methods: {
        setUp() {
            if (this.coordinates === undefined) {
                this.coordinates = new Coordinates();
                this.shapesManager = new Shapes();
                this.shapes = [];
            }
        },
        drawDeliveryProject() {
            this.setUp();
            this.deliveryProjects.forEach(async (deliveryProject) => {
                if (typeof first(deliveryProject.path) === 'undefined') {
                    return;
                }

                const shape = await this.drawingManager.addShape(
                    deliveryProject.id,
                    deliveryProject.id,
                    first(deliveryProject.path).coordinates[0],
                    false,
                );

                this.shapesManager.setBorder(shape, '#0b90a2');
                if (deliveryProject.id === this.currentDeliveryProject.id) {
                    this.shapesManager.setBorder(shape, '#0e9919');
                    this.shapesManager.setBackground(shape, 'rgba(14, 153, 25, 0.7)');
                    this.$emit('currentDeliveryProjectDrawn', shape);
                }

                shape.addListener('click', () => {
                    EventBus.$emit('delivery-project-clicked', deliveryProject);
                });

                this.shapes.push(shape);
            });

            this.$emit('rendered');
            EventBus.$emit('delivery-project-drawn', this.shapes);
        },
    },
    watch: {
        deliveryProject: {
            handler: function (newDeliveryProject) {
                this.drawDeliveryProject();
            },
            immediate: false,
        },
    },
});
